const getApiOrigin = () => {
  const origin = process.env.REACT_APP_API_BASE_URL?.trim().replace(/\/+$/, "");

  if (!origin) {
    throw new Error("Missing REACT_APP_API_BASE_URL");
  }

  return origin;
};

export const getApiBaseUrl = () => `${getApiOrigin()}/api`;

export const getTemplateGeneratorBaseUrl = () =>
  `${getApiOrigin()}/template-generator`;

export const getEngagementsBaseUrl = () => `${getApiBaseUrl()}/engagements`;

export const getChatbotUrl = () => `${getApiOrigin()}/chat`;

export const getGa4OAuthRedirect = () =>
  `${getApiOrigin()}/api/ga4/oauth/callback`;

export const getGadsOAuthRedirect = () =>
  `${getApiOrigin()}/api/gads/oauth/callback`;

export const getApiOriginUrl = () => getApiOrigin();
